import { Fragment } from 'react';
import {
  InlineNotification,
  NotificationType,
} from '@spotted-zebra-uk/ui-components';
import styles from './SkillsCategoryOverview.module.scss';

const SkillsCategoryInlineNotification = ({
  roleName,
  missingCategorySkills,
}: {
  roleName: string;
  missingCategorySkills: string[];
}) => {
  return (
    <InlineNotification
      notificationType={NotificationType.ERROR}
      title={roleName}
    >
      <p>
        Add{' '}
        {missingCategorySkills.map((skill, index) => (
          <Fragment key={skill}>
            <span className={styles.missingSkills} key={skill}>
              {skill}
              {index < missingCategorySkills.length - 1 &&
                index !== missingCategorySkills.length - 2 &&
                ', '}
            </span>
            {index === missingCategorySkills.length - 2 && ' and '}
          </Fragment>
        ))}{' '}
        as {missingCategorySkills.length === 1 ? 'a' : ''} skill
        {missingCategorySkills.length === 1 ? '' : 's'} to ensure the company
        app and generated reports display correctly.
      </p>
    </InlineNotification>
  );
};

export default SkillsCategoryInlineNotification;
